import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {withTranslation} from "react-i18next";
import clsx from "clsx";
import * as colors from "../../../../constants/colors";
import imgTraining from "../../../../images/formation.jpg";
import logo from "../../../../images/logo.png";
import logoPartner1 from "../../../../images/partners/logo-Kaleidi.jpg";
import logoPartner2 from "../../../../images/partners/logo-UBO.png";
import logoPartner3 from "../../../../images/partners/Logo_universite_montpellier.png";
import logoPartner4 from "../../../../images/partners/MMI.png";
import Carousel from "react-material-ui-carousel";
const styles = (theme) => ({
    container:{
        [theme.breakpoints.down("sm")]:{
            flexDirection: "column-reverse",
            alignItems: "center"
        }
    },
    loginBlock:{

    },
    presentation:{

    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: "#ffd02f",
        minHeight: 600,
        borderRadius: 6,
        position: "relative",
        width: "100%",
        maxWidth: 400
    },
    textField:{
        "& fieldset":{
            color: colors.DARK_COLOR
        },
        "& input,& label,& legend span,& label.Mui-focused":{
            color: colors.DARK_COLOR
        },
        "& $notchedOutline":{
            borderColor:colors.DARK_COLOR
        },
        "&>div":{
            background:"#fff",
        }
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
    },
    form: {
        width: '100%',
        marginTop: "1rem",
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        minHeight: "3.5rem"
    },
    formContainer:{
        backgroundColor: "rgba(255,255,255,.6)",
        marginTop: "2rem",
        borderRadius: 6,
        padding: "2rem 1rem",
        maxWidth: 300,
        border: "1px solid #00000026"
    },
    connectionTitle:{
        position: "absolute",
        top:"4.25rem"
    },
    logoPlaisirMath:{
        marginTop: "1rem"
    },
    imgTraining:{
        marginTop: "3.5rem",
        borderRadius: 6
    },
    trainingDescription:{
        marginTop: "1rem",
        color: colors.DARK_COLOR
    },
    passwordVisibilityIcon:{
        "&:hover":{
            cursor: "pointer"
        }
    },
    logoSlider:{
        textAlign: "center",
        marginTop: "1rem",
        "& img":{
            maxWidth: "80%",
            maxHeight: "80px"
        }
    },
    loadingLogin:{
        marginRight: ".5rem"
    }
});

function Layout(props) {
    const {classes,t,contentComponent} = props;
    const bannerItems = [logoPartner1,logoPartner2,logoPartner3,logoPartner4];
    return (
        <Container maxWidth={"lg"}>
            <Grid container spacing={2} sm={12} xs={12} justify={"center"} alignItems={"stretch"} className={classes.container}>
                <Grid item xs={12} sm={12} md={5} lg={4} className={clsx(classes.presentation,classes.paper)}>
                    <img className={classes.logoPlaisirMath} src={logo} alt={"logo"}/>
                    <img className={classes.imgTraining} src={imgTraining} alt={"formation"} width={"100%"}/>
                    <Typography className={classes.trainingDescription}>
                        {t("text.game_description")}
                    </Typography>
                    <Carousel className={classes.logoSlider} navButtonsAlwaysInvisible={true} interval={5000}>
                        {
                            bannerItems.map( (item, i) => <img key={i} src={item} /> )
                        }
                    </Carousel>
                </Grid>
                <Grid md={1}/>
                {contentComponent}
            </Grid>
        </Container>
    );
}

export default withStyles(styles)(withTranslation()(Layout));
